import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow } from "../site/Motion";
import { WEDDING_STYLES, slug } from "../../lib/site";

export const Styles = () => {
  const [active, setActive] = useState(0);
  return (
    <section data-testid="styles-section" className="bg-cypress text-cream">
      <div className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12 py-24 sm:py-32 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-7">
          <Eyebrow light>Che coppia siete?</Eyebrow>
          <Reveal><h2 className="mt-4 font-serif text-4xl sm:text-6xl leading-[1.05]">Quattro anime, <em className="text-terra-light">infinite</em> sfumature.</h2></Reveal>
          <ul className="mt-14 border-t border-cream/15">
            {WEDDING_STYLES.map((s, i) => (
              <li key={s.key} className="border-b border-cream/15">
                <Link to={`/portfolio?stile=${encodeURIComponent(s.key)}`} data-testid={`style-link-${slug(s.key)}`} onMouseEnter={() => setActive(i)}
                  className="group flex items-center gap-5 py-6 sm:py-8">
                  <img src={s.img} alt="" aria-hidden className="lg:hidden w-16 h-20 object-cover rounded-t-full" />
                  <span className="font-mono text-xs text-cream/70 w-8">0{i + 1}</span>
                  <span className={`flex-1 font-serif text-3xl sm:text-5xl transition-[color,transform] duration-500 group-hover:translate-x-3 ${active === i ? "text-cream" : "text-cream/60"}`}>{s.key}</span>
                  <span className="hidden sm:block text-sm text-cream/70">{s.note}</span>
                  <ArrowUpRight className="w-5 h-5 shrink-0 text-cream/70 group-hover:text-terra-light group-hover:rotate-45 transition-transform duration-500" />
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="hidden lg:block lg:col-span-5">
          <div className="sticky top-28 aspect-[3/4] rounded-t-[999px] overflow-hidden">
            {WEDDING_STYLES.map((s, i) => (
              <img key={s.key} src={s.img} alt={s.key}
                className={`absolute inset-0 w-full h-full object-cover transition-[opacity,transform] duration-[900ms] ease-out ${active === i ? "opacity-100 scale-100" : "opacity-0 scale-110"}`} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
